import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from 'src/api';
import { RelatedServiceStatus } from 'src/pages/billing/billing.types';

import {
  Grade,
  Location,
  SessionActivity,
  SessionCancellationReason,
  SessionOutcome,
  SessionParticipation,
  StudentActivity,
} from './dictionaries.types';

export const dictionariesApi = createApi({
  reducerPath: 'dictionariesApi',
  baseQuery,
  keepUnusedDataFor: 0,
  endpoints: (build) => ({
    grades: build.query<Grade[], void>({
      query: () => '/Dictionary/grade',
    }),
    location: build.query<Location[], void>({
      query: () => '/Dictionary/session-location',
    }),
    sessionCancellationReason: build.query<SessionCancellationReason[], void>({
      query: () => '/Dictionary/session-cancellation-reason',
    }),
    studentActivities: build.query<StudentActivity[], void>({
      query: () => '/Dictionary/student-activities',
    }),
    sessionActivity: build.query<SessionActivity[], void>({
      query: () => '/Dictionary/session-activity',
    }),
    sessionParticipation: build.query<SessionParticipation[], void>({
      query: () => '/Dictionary/session-participation',
    }),
    sessionOutcome: build.query<SessionOutcome[], void>({
      query: () => '/Dictionary/session-outcome',
    }),
    getRelatedServiceStatus: build.query<RelatedServiceStatus[], void>({
      query: () => '/Dictionary/related-service-status',
    }),
  }),
});

export const {
  useGradesQuery,
  useLocationQuery,
  useSessionCancellationReasonQuery,
  useStudentActivitiesQuery,
  useSessionActivityQuery,
  useSessionParticipationQuery,
  useSessionOutcomeQuery,
  useGetRelatedServiceStatusQuery,
} = dictionariesApi;
